<template>
    <section class="container">
      <div class="route">
        {{$locales.ajustes.ajustes}} > {{$locales.ajustes.seguridadclaves.seguridadclaves}} > {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
      </div>
      <div class="sidebar">
        <span class="principal">
          <span class="icon">J  </span>{{$locales.ajustes.ajustes}}
        </span>
        <ul>
          <li @click="toggle">
            <span class="sidebar-item"><span class="arrow">&#9660;</span>{{$locales.ajustes.alertas.alertas}}</span>
                <router-link to="/onesaitConfirmingProviders/ajustes/alertas/facturas"  class="link" v-if="active">
                  {{$locales.ajustes.alertas.facturas}}
                </router-link>
          </li>
          <li  @click="toggle2">
                <span class="sidebar-item">
                  <span class="arrow">&#9660; </span> {{$locales.ajustes.seguridadclaves.seguridadclaves}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/modificar-contrasena"  class="link" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarpassword}}
                </router-link>
                <span @click="refresh"><router-link to="/onesaitConfirmingProviders/ajustes/modificar-claveFirma"  class="link-active" v-if="active2">
                {{$locales.ajustes.seguridadclaves.modificarclavefirma}}
                </router-link></span>
          </li>
          <li @click="toggle3">
                 <span class="sidebar-item">
                  <span class="arrow">&#9660; </span>{{$locales.ajustes.datospersonales.datospersonales}}
                </span>
                <router-link to="/onesaitConfirmingProviders/ajustes/datos-personales/modificar-datos"  class="link" v-if="active3">
                  {{$locales.ajustes.datospersonales.modificardatos}}
                </router-link>
          </li>
        </ul>
      </div>
      <div class="window">
         <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Operación realizada con éxito</h3>
        </div>
        <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <h1>{{$locales.ajustes.seguridadclaves.modificarclavefirma}}</h1>
          <div class="form-group">
            <form class="window-form" @submit.prevent="aceptar">
              <div class="row3">
                <div class="elemento">
                  <label for="actualSig">* Clave actual</label>
                  <input disabled maxlength="8" :class = "(submitted &&$v.model.actualSig.$invalid)?'inputInvalidDisabled':'inputComponentDisabled'" type="password" id="actualSig" name="actualSig" autocomplete="off" v-model="model.actualSig"/>
                  <div class="error" v-if="submitted && !$v.model.actualSig.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.actualSig.minLength">El campo debe tener como mínimo 8 caracteres</div>
                  <label for="newSig">* Nueva clave</label>
                  <input disabled maxlength="8" :class = "(submitted &&$v.model.newSig.$invalid)?'inputInvalidDisabled':'inputComponentDisabled'" type="password" id="newSig" name="newSig" autocomplete="off" v-model="model.newSig"/>
                  <div class="error" v-if="submitted && !$v.model.newSig.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.newSig.minLength">El campo debe tener como mínimo 8 caracteres</div>
                  <div class="error" v-if="submitted && !$v.model.newSig.differentFromactualSig">La nueva clave no puede tener el mismo valor que la clave actual</div>
                  <label for="newSigRep">* Repite la nueva clave</label>
                  <input disabled maxlength="8" :class = "(submitted && $v.model.newSigRep.$invalid)?'inputInvalidDisabled':'inputComponentDisabled'" type="password" id="newSigRep" name="newSigRep" autocomplete="off" v-model="model.newSigRep"/>
                  <div class="error" v-if="submitted && !$v.model.newSigRep.required">Este campo es obligatorio</div>
                  <div class="error" v-if="submitted && !$v.model.newSigRep.minLength">El campo debe tener como mínimo 8 caracteres</div>
                  <div class="error" v-if="submitted && !$v.model.newSigRep.sameAsnewSig">El campo debe tener el mismo valor que la nueva clave</div>
                </div>
                  <div class="botonera" id="modificarClave" v-if=beforeSubmit>
                    <div class="botones">
                      <button type="button" v-for="num in numeros" v-bind:key="num" class="botonPantalla" @click="tecladoVirtual($event)">{{num}}</button>
                    </div>
                    <button type="button" class="botonBorrar" @click="borrar()">
                      Borrar
                    </button>
                  </div>
              </div>
                  <input class="btnPrimary" type="submit" value="Aceptar" :disabled="isDisabled" v-if=beforeSubmit>
                  <br><hr/>
                  <p id="subTextPassword">
                    <b>Pautas para elegir una clave de firma</b><br>
                    <ul class="circulos">
                      <li>Debe constar de 8 dígitos.</li>
                      <li>No se permiten letras o caracteres especiales.</li>
                      <li>No deben repetirse claves anteriores.</li>
                      <li>No se permiten números consecutivos (Ej: 123456).</li>
                      <li>No se permiten números repetidos (Ej: 111111).</li>
                    </ul>
                  </p>
                  <br>
              <div v-if=datosOTP>
                <OTPComponent :params="params" :datosOTP="datosOTP" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelarOTP"></OTPComponent>
              </div>
            </form>
          </div>
          <div v-if=datosFirma>
            <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
      </div>
    </section>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import ChangeSignature from '../models/ChangeSignature';
import SignatureComponent from './SignatureComponent';
import OTPComponent from './OTPComponent';  
export default {
    name : 'ChangeSignatureComponent',
    data(){
      return{
        numeros:null,
        datosFirma: null,
        active: false,
        active2: true,
        active3: false,
        submitted: false,
        mensajeError: null,
        params: null,
        datosOTP: null,
        llamada: null,
        beforeSubmit: true,
        confirmacion: null,
        model : new ChangeSignature()
      }
    },
    components: {
      SignatureComponent,
      OTPComponent
    },
    computed : {
      isDisabled: function() {
        return  !this.model.actualSig || !this.model.newSig || !this.model.newSigRep;
      }
    },
    validations : {
      model : {
        actualSig: {
          required,
          minLength: minLength(8),
        },
        newSig: {
          required,
          minLength: minLength(8),
          differentFromactualSig: function() {
            return (this.model.actualSig!=this.model.newSig);
          }
        },
        newSigRep: {
          required,
          minLength: minLength(8),
          sameAsnewSig: function() {
            return (this.model.newSig==this.model.newSigRep);
          }
        }
      }
    },
    mounted: function(){
      var arrayTeclado=new Array();
      var numActual;
      var i;
      for(i=0;i<10;i){
        numActual=Math.floor(Math.random() * 10);
        if(!arrayTeclado.includes(numActual)){
          arrayTeclado.push(numActual);
          i++;
        }
      }
      this.numeros=arrayTeclado;
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      callBackAceptar(confirmacion, result,otp){
        this.beforeSubmit = false;
        if(confirmacion=='KO' && otp==null){ //esto evita que salga el 0096H que simplemente es un indicador de que requiere OTP
          this.confirmacion=confirmacion;
          this.mensajeError=result;
        }else{ //si ya va bien, quitamos los mensajes de error previos con confirmacion=null
          this.confirmacion=null;
          this.datosFirma = null;
          this.datosOTP=otp;
        }
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.submitted=false;
        this.mensajeError = mensaje;
        if(confirmacion == "OK") {
          this.callBackCancelarOTP(); //son las instrucciones necesarias para resetear la pantalla como al comienzo
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
        } else {
          window.scroll({
              top: 470,
              left: 0,
              behavior: 'smooth'
          });
          if(codError == '095H') { //clave otp incorrecta
          }else if (codError == '089H') {
            this.datosOTP = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          }else{ //si es un error distinto del bloqueo de usuario o clave otp incorrecta, la otp se comporta como si la cancelaramos
            this.callBackCancelarOTP();
          }
        }
      },
     callBackCancelarOTP(){
         this.beforeSubmit = true;
         this.submitted=false;
         this.datosOTP = null;
      },
      toggle () {
        this.active = true;
        this.active2 = false;
        this.active3 = false;
      },
      toggle2 () {
        this.active = false;
        this.active2 = true;
        this.active3 = false;
      },
       toggle3 () {
        this.active = false;
        this.active2 = false;
        this.active3 = true;
      },
      tecladoVirtual(elemento){
          if(!this.$v.model.actualSig.required){
            this.model.actualSig=elemento.target.innerHTML;
          }else if(!this.$v.model.actualSig.minLength){
            this.model.actualSig+=elemento.target.innerHTML;
          }else if(!this.$v.model.newSig.required){
            this.model.newSig=elemento.target.innerHTML;
          }else if(!this.$v.model.newSig.minLength){
            this.model.newSig+=elemento.target.innerHTML;
          }else if(!this.$v.model.newSigRep.required){
            this.model.newSigRep=elemento.target.innerHTML;
          }else if(!this.$v.model.newSigRep.minLength){
            this.model.newSigRep+=elemento.target.innerHTML;
          }
      },
      borrar(){
        if(!this.$v.model.actualSig.minLength || (this.$v.model.actualSig.minLength && this.model.newSig==null)){
          this.model.actualSig=null;
        }else if(!this.$v.model.newSig.minLength || (this.$v.model.newSig.minLength && this.model.newSigRep==null)){
          this.model.newSig=null;
        }else{
          this.model.newSigRep=null;
        }
      },
      aceptar() {
        this.confirmacion=null;
        this.submitted = true;
          this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            const ventana=this;
            const baseURI = '/api-users/users/me/signatureKey';
            this.llamada = {
              urlEndpoint : baseURI,
              metodo : 'PUT'
            };
            this.params = {
              oldKey : this.model.actualSig,
              newKey: this.model.newSig,
              repeatNewKey: this.model.newSigRep
            };
            let loader = this.$loading.show();
            this.$http.put(baseURI, this.params)
            .then(() => {
              ventana.confirmacion='OK';
            })
            .catch(error => {
              if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                      ventana.datosOTP = error.response.data.result.errors[0].info;
                    }else{ //pide clave de firma
                      this.datosFirma = error.response.data.result.errors[0].info;
                    }
                    this.beforeSubmit = false;
                  }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                          ventana.confirmacion='KO';
                          ventana.beforeSubmit=true;
                          window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                          });
                        }
                }else{
                        if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                          ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                        }
                        ventana.confirmacion='KO';
                        ventana.beforeSubmit=true;
                        window.scroll({
                          top: 0,
                          left: 0,
                          behavior: 'smooth'
                        });
                      }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
                ventana.beforeSubmit=true;
              }
            })
            .then(function () {
              loader.hide();
            });
          }
      }
    }
}
</script>